import { Avatar } from '@fiverr-private/fit';

export default Avatar;
